// extracted by mini-css-extract-plugin
export default {"tooltipWrapper":"Tooltip_tooltipWrapper__ac6EX","tooltipContent":"Tooltip_tooltipContent__333p+"};